import { render } from "./Language.vue?vue&type=template&id=1340a9f2"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
script.render = render

export default script